import { prepareBanks } from 'shared/mappers/prepareBanks';
import { prepareMortgageBanner } from 'shared/mappers/prepareMortgageBanner';
import {
  type TGetCachedContentResponse,
  fetchGetCachedContent,
} from 'shared/repositories/special-promos/v1/get-cached-content';
import { type IApplicationContext } from 'shared/types/applicationContext';
import { ResponseError } from 'shared/utils/errors';

import { type ISpecialProjectsBlocks } from './types';

type GetSpecialProjectsBlocksParams = {
  context: IApplicationContext;
  regionId: number;
};

export async function getSpecialProjectsBlocks({
  context: { logger, httpApi },
  regionId,
}: GetSpecialProjectsBlocksParams): Promise<ISpecialProjectsBlocks> {
  try {
    const { response, statusCode } = await fetchGetCachedContent<TGetCachedContentResponse, TGetCachedContentResponse>({
      httpApi,
      parameters: {
        blocks:
          'banksPik,newbuildingsPlusBlocksPik,phonesPik,mortgageBannerPik,mortgageCalculatorPik,developerAwards,developerRatings',
        regionId,
      },
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'getSpecialProjectsBlocks',
        message: 'Не удалось получить контент для блоков специальных проектов',
      });
    }

    return {
      banksPik: response.banksPik ? prepareBanks(response.banksPik) : [],
      developerAwards: response.developerAwards ?? null,
      developerRatings: response.developerRatings ?? null,
      facts: response.facts ?? [],
      mortgageBannerPik: response.mortgageBannerPik ? prepareMortgageBanner(response.mortgageBannerPik) : null,
      mortgageCalculatorPik: response.mortgageCalculatorPik ?? null,
      newbuildingsPlusBlocksPik: response.newbuildingsPlusBlocksPik ?? [],
      phone: response.phonesPik?.phone ? `+${response.phonesPik?.phone}` : '',
    };
  } catch (ex) {
    logger.warning(ex as Error, { message: 'Получение актуальной версии блоков спецпроектов завершилось ошибкой' });

    return {
      banksPik: [],
      developerAwards: null,
      developerRatings: null,
      facts: [],
      mortgageBannerPik: null,
      mortgageCalculatorPik: null,
      newbuildingsPlusBlocksPik: [],
      phone: '',
    };
  }
}
